<template>
  <div class="form-role-user">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.unit_products')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('forms.inputs.searchProduct')"
                  v-model="productSearch.name"
                  @focus="searchResult = false, add_button_disabled = true, product.id = ''"
                />
              </div>

              <div class="flex md1 sm1 xs12">
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-search"
                  class="mr-1"
                  @click="getProduct()"
                />
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-close"
                  class="mr-1"
                  @click="resetlabels()"
                />
              </div>
            </div>

            <div class="row" v-if="searchResult == true">
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.inputs.product')"
                  v-model="product.id"
                  keyBy="id"
                  textBy="name"
                  :options="productsList"
                  noOptionsText="Nenhum produto encontrado"
                />
              </div>
            </div>

          <div class="row">
            <div class="flex xs12 sm3">
              <va-button
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                :disabled="add_button_disabled"
                @click="createUnitProduct(product.id)"
              >
                {{ $t('menu.add') }}
              </va-button>
              <va-button
                medium
                inline
                color="secondary"
                icon="fa fa-cloud-upload"
                class="ml-2"
                @click="$router.push({name: 'import-unit-products'})">
                {{ $t('menu.import') }}
              </va-button>
            </div>
          </div>

            <va-data-table
              :fields="fields"
              :data="products"
              no-pagination
            >
              <template slot="actions" slot-scope="props">
                <va-button
                  small
                  inline
                  color="danger"
                  icon="fa fa-remove"
                  class="ma-0"
                  @click="showModalRemove = true, id_to_remove = props.rowData.id"
                >
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
            </va-data-table>
              <va-modal
                v-model="showModalRemove"
                size="small"
                :title="$t('modal.remove')"
                :message="$t('modal.messageRemoveUnitProduct')"
                hideDefaultActions
                :color="this.$themes.secondary"
              >
              <va-button
                color="danger"
                class="ma-2"
                @click="showModalRemove = false">
                {{$t('modal.cancel')}}
              </va-button>

              <va-button
                color="secondary"
                class="ma-2"
                @click="deleteUnitProduct(id_to_remove)">
                {{$t('modal.confirm')}}
              </va-button>
            </va-modal>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import ProductAPI from '@/services/ProductAPI'
import { showError } from '@/global'

export default {
  name: 'form-role-user',
  components: {},
  data () {
    return {
      showModalRemove: false,
      add_button_disabled: true,
      id_to_remove: '',
      product: {
        id: '',
        name: '',
      },
      productSearch: {
        name: '',
      },
      products: [],
      productsList: [],
      searchResult: false,
    }
  },
  mounted () {
    this.getUnitProducts()
  },
  methods: {
    getUnitProducts () {
      ProductAPI.getUnitProducts().then(response => {
        this.products = response.data.unit_products
      })
    },

    getProduct () {
      ProductAPI.getProductByName(this.productSearch.name).then(response => {
        this.productsList = response.data.products
        this.add_button_disabled = false
        this.searchResult = true
      })
    },

    createUnitProduct (product) {
      let productId = ''

      if (product !== undefined) {
        productId = product
      }

      if (typeof product === 'object') {
        productId = product.id
      }

      ProductAPI.createUnitProduct(productId).then(response => {
        this.resetlabels()
        this.getUnitProducts()
        this.showModalRemove = false
        this.add_button_disabled = true
        this.searchResult = false
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    deleteUnitProduct (id) {
      ProductAPI.deleteUnitProduct(id).then(response => {
        this.resetlabels()
        this.getUnitProducts()
        this.showModalRemove = false
        this.add_button_disabled = true
        this.searchResult = false
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    resetlabels () {
      this.productSearch.name = ''
      this.product.name = ''
      this.product.id = ''
      this.add_button_disabled = true
      this.searchResult = false
    },
  },

  computed: {
    fields () {
      return [{
        name: 'product_id',
        title: this.$t('tables.products.id'),
        width: '3%',
      },
      {
        name: 'name',
        title: this.$t('tables.products.label'),
        width: '25%',
      },
      {
        name: 'fragility',
        title: this.$t('tables.packages.fragility'),
        width: '10%',
      },
      {
        name: 'package',
        title: this.$t('tables.packages.name'),
        width: '10%',
      },
      {
        name: 'integration_id',
        title: this.$t('tables.products.staging'),
        width: '15%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },
}
</script>
